
import { gql } from '@apollo/client'

export type RedeemInput = {
  offerId: string
}

export type RedeemOutput = {
  message: string
  offerLink: string
  redeemCode: string
  redemptionInstructions: string
  validUntil?: string
}

const query = gql`
  mutation redeemOffer($offerId: String!) {
    redeemOffer(offerId: $offerId) {
      message
      offerLink
      redeemCode
      redemptionInstructions
      validUntil
    }
  }
`

const mapFn = (data: any): RedeemOutput => ({
  message: data?.redeemOffer?.message,
  offerLink: data?.redeemOffer?.offerLink,
  redeemCode: data?.redeemOffer?.redeemCode,
  redemptionInstructions: data?.redeemOffer?.redemptionInstructions,
  validUntil: data?.redeemOffer?.validUntil,
})

export const redeemMutation = {
  query,
  mapFn,
}
